/**
 * 处理socket消息发送-推送事件
 * 
 */
import {getLoginId,dbType2SocketType} from '../functions/Common.js'
import {getCustomList} from '../network/local/custom.js'

/**
 * 推送init事件
 */
export function pushInit(){
	getCustomList(data=>{
		let phoneIds = []
		for (let i = 0; i < data.length; i++) {
			phoneIds.push(data[i].phone_id)
		}
		let bind = {
			type:'event',
			status:true,
			bean:{
				type:'bindBrow',
				fromId:getLoginId(),
				toId:phoneIds.join(',')
			}
		};
		SocketConnect.send(JSON.stringify(bind));
	})
}

/**
 * 推送查看客服朋友圈的指令
 * @param {phoneId} 客服weiI
 * @param {snsId} 最后一条的朋友圈的snsId
 */
export function pushCustomSns(phoneId,snsId){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  phoneId: phoneId,
			  snsId: snsId,
			  type: 'CustomSns'
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 推送查看粉丝朋友圈的指令
 * @param {phoneId} 客服weiI
 * @param {snsId} 最后一条的朋友圈的snsId
 * @param {fansWxid} 粉丝的wxid
 */
export function pushFansSns(phoneId,fansWxid,snsId){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  isFans: 1,
			  phone_id: phoneId,
			  snsId: snsId,
			  wxid: fansWxid,
			  type: 'fansSns'
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 发送客服朋友圈
 * @param {Object} data
 * @param {Object} fromId
 * @param {Object} phoneId
 */
export function pushSendMoment(data,fromId,phoneId,id){
	// 初始值
	let is_image = 1
	let cover = ''
	let url_content = ''
	let url = ''
	let imgUrl = data.imgUrl
	// 数据类型处理
	if(data.type == 1){
		if(imgUrl instanceof Array){
			imgUrl = imgUrl.join(',')
		}
	}else if (data.type == 2) {
		cover = data.cover
		is_image = 2
	}else if(data.type == 3){
		url_content = data.urlContent
		url = data.url
		is_image = 4
	}else{
		is_image = data.type
	}
	let qq_maps = {}
	if(data.qq_maps !== undefined){
		qq_maps = data.qq_maps
	}
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			type:'article',
			id: id,
			content: data.content,
			fromId: fromId,
			phoneId:phoneId,
			base64: imgUrl,
			is_image: is_image,
			cover: cover,
			url_content: url_content,
			url: url,
			qq_maps:qq_maps
		}
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 推送朋友圈评论，点赞事件
 * @param {Object} phoneId
 * @param {Object} snsType
 */
export function pushMomentsReply(phoneId,snsType,data){
	let toId = data.friend_open_id
	if(data.account_comment_id != '0'){
		toId = data.argued_open_id
	}
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  commentId: data.account_comment_id,
			  phoneId: phoneId,
			  sendWord: data.content,
			  snsId: data.account_sns_id,
			  snsType: snsType,
			  snsUserId: data.friend_open_id,
			  toId: toId,
			  type: 'replyMoment'
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 朋友圈置顶/取消置顶
 * @param {Object} phoneId
 * @param {Object} snsId
 * @param {Object} eventValue
 */
export function pushMomentsTop(phoneId,snsId,eventValue){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  phoneId: phoneId,
			  snsId: snsId,
			  eventValue: eventValue,
			  type: 'topMoment'
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 推送添加粉丝事件
 * @param {Object} from_vxid 粉丝wxid
 * @param {Object} scene 场景值
 * @param {Object} ticket 票据
 * @param {Object} weiI 客服手机phoneID
 */
export function pushPassFans(from_vxid,scene,ticket,weiI){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  from_vxid: from_vxid,
			  scene: scene,
			  ticket:ticket,
			  weiI: weiI,
			  type: 'passFans'
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 向群中添加群成员
 * @param {Object} clusterId
 * @param {Object} customId 客服id
 */
export function pushAddMemberFromRoom(clusterId,customId){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  clusterId: clusterId,
			  customId:customId,
			  type: 'C_AddMemberFromRoom'
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 删除群成员
 * @param {Object} clusterId
 */
export function pushDelMemberFromRoom(clusterId){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  clusterId: clusterId,
			  type: 'C_DelMemberFromRoom'
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 更新群二维码
 * @param {Object} clusterId
 * @param {String} c_wxid 客服微信id
 */
export function pushUpdateWechatQr(clusterId,c_wxid){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  clusterId: clusterId,
			  c_wxid: c_wxid,
			  type: 'update_wechatQr'
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 修改群名称
 * @param {Object} clusterId
 */
export function pushRemarkRoomName(clusterId){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  clusterId: clusterId,
			  type: 'C_RemarkRoomName'
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 修改群公告
 * @param {Object} clusterId
 */
export function pushSetRoomAnnouncement(clusterId){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  clusterId: clusterId,
			  type: 'C_SetRoomAnnouncement'
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 同步群成员
 * @param {Object} clusterId
 */
export function pushGetRoomMembers(clusterId){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  clusterId: clusterId,
			  type: 'C_GetRoomMembers'
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 修改我在群内的昵称
 * @param {Object} memberId 成员主键id
 * @param {Object} nickname 修改后的的昵称
 */
export function pushModifyNickName(memberId,nickname){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  memberId: memberId,
			  nickname:nickname,
			  type: 'C_ModifyNickName'
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 推送退群指令
 * @param {Object} clusterId 群主键id
 * @param {Object} c_wxid 客服微信id
 */
export function pushExitChatRoom(clusterId,c_wxid){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  clusterId: clusterId,
			  c_wxid: c_wxid,
			  type: 'C_ExitChatRoom'
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 创建新群
 * @param {Object} clusterId 群主键id
 */
export function pushCreateChatRoom(clusterId){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  clusterId: clusterId,
			  type: 'C_CreateChatRoom'
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 推送同步客服群列表指令
 */
export function pushC_SyncCluster(openId,phoneId){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{ 
			  managerId: getLoginId(),
			  openId: openId,
			  phoneId: phoneId,
			  type: "C_SyncCluster"
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 推送修改备注事件
 * @param {Object} conRemark 修改后的备注
 * @param {Object} phoneId 客服phpenid
 * @param {Object} wxid 粉丝的wxid
 */
export function pushReConRemark(conRemark,phoneId,wxid){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  conRemark: conRemark,
			  phoneId: phoneId,
			  wxid: wxid,
			  type: 'reConRemark'
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 推送修改粉丝指令
 * @param {Object} customId
 * @param {Object} fansType
 * @param {Object} phoneId
 * @param {Object} wxid
 */
export function pushEditFansType(customId,fansType,phoneId,wxid){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  customId: customId,
			  fansType: fansType,
			  phoneId: phoneId,
			  wxid: wxid,
			  type: 'editFansType'
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 推送添加粉丝标签指令
 */
export function pushTagsUpdate(account_wxid,friend_id,friend_wxid,phoneId,tags_value){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  account_wxid: account_wxid,
			  friend_id: friend_id,
			  friend_wxid: friend_wxid,
			  phoneId: phoneId,
			  tags_value: tags_value,
			  type: 'TagsUpdate'
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 推送删除粉丝标签指令
 */
export function pushTagsDelete(account_wxid,friend_id,friend_wxid,phoneId,tags_value){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  account_wxid: account_wxid,
			  friend_id: friend_id,
			  friend_wxid: friend_wxid,
			  phoneId: phoneId,
			  tags_value: tags_value,
			  type: 'TagsDelete'
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 推送同步粉丝标签指令
 */
export function pushTagsSync(account_wxid,friend_id,friend_wxid,phoneId){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  account_wxid: account_wxid,
			  friend_id: friend_id,
			  friend_wxid: friend_wxid,
			  phoneId: phoneId,
			  type: 'TagsSync'
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 推送打开红包指令-进入开启红包页面
 */
export function pushRedPackage(nativeurl,paymsgid,content,fromId,toId,weiI){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  nativeurl: nativeurl,
			  paymsgid: paymsgid,
			  content: content,
			  fromId: fromId,
			  toId: toId,
			  weiI: weiI,
			  adminId: getLoginId(),
			  type: 'redPackage'
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 推送打开红包指令-确认收取红包
 */
export function pushRedPackageOpen_S(sendId,cGE,nuh,timingIdentifier,c_wx_name,phoneId){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  sendId: sendId,
			  cGE: cGE,
			  nuh: nuh,
			  timingIdentifier: timingIdentifier,
			  phoneId: phoneId,
			  c_wx_name,c_wx_name,
			  type: 'redPackageOpen_S'
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 推送打开转账指令-进入收款页面
 */
export function pushTransferAccounts(invalidtime,paysubtype,transcationid,transferid,wxid,content,fromId,toId,money,weiI){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  invalidtime:invalidtime,
			  paysubtype:paysubtype,
			  transcationid:transcationid,
			  transferid:transferid,
			  wxid:wxid,
			  content:content,
			  fromId:fromId,
			  toId:toId,
			  money:money,
			  weiI:weiI,
			  adminId:getLoginId(),
			  type:'transferAccounts',
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 推送打开转账指令-确认收款
 */
export function pushTransferAccountsOpen_S(trans_id,transfer_id,wxid,confirm,invalid_time,fee,phoneId){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  trans_id: trans_id,
			  transfer_id: transfer_id,
			  wxid: wxid,
			  confirm: confirm,
			  invalid_time: invalid_time,
			  fee: fee,
			  phoneId: phoneId,
			  type: 'transferAccountsOpen_S'
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 推送消息撤回的指令
 */
export function pushMessageWithdraw(field_msgId,recodeId,phoneId,chatType){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{ 
			  field_msgId: field_msgId,
			  phoneId: phoneId,
			  recodeId: recodeId,
			  chatType: chatType,
			  content: "您撤回了一条消息!",
			  type: "messageWithdraw"
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 推送客服粉丝同步指令
 */
export function pushSysFans(phoneId){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  phoneId: phoneId,
			  type: "sys_fans"
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 推送重启手机指令
 */
export function pushRestartPhone(phoneId){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  phoneId: phoneId,
			  type: "restart_phone"
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}


/**
 * 同步粉丝聊天记录
 * @param {Object} phoneId 机型号
 * @param {Object} fans_wxid 粉丝wxid
 * @param {Object} start_time 聊天记录开始时间
 * @param {Object} end_time 聊天记录结束时间
 */
export function syncFansRecord(phoneId,fans_wxid,start_time,end_time){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  phoneId: phoneId,
			  fans_wxid: fans_wxid,
			  start_time: start_time,
			  end_time: end_time,
			  type: "sync_fans_record"
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 推送清除小红点-未读消息
 */
export function pushClearRedDot(phoneId){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  phoneId: phoneId,
			  type: "clear_red_dot"
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}

/**
 * 推送对话转移事件
 * @param {Object} adminId
 * @param {Object} fans_id
 * @param {Object} to_org
 */
export function transferFans(adminId,custom_id,fans_id,to_org){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{
			  adminId: adminId,
			  customId: custom_id,
			  fansId: fans_id,
			  toOrg: to_org,
			  type: "transfer_fans"
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}


/**
 * 转账撤回
 * @param {Object} transcationid
 * @param {Object} transferid
 * @param {Object} fromId
 * @param {Object} phoneId
 */
export function transferReturn(transcationid,transferid,fromId,id,phoneId){
	// socket推送消息
	let sendData = {
		  state: true,
		  type: 'event',
		  bean:{ 
			  transcationid: transcationid,
			  phoneId: phoneId,
			  transferid: transferid,
			  fansId: fromId,
			  msg_id:id,
			  type: "transferReturn"
		  }
	}
	SocketConnect.send(JSON.stringify(sendData))  
}